import { render, staticRenderFns } from "./tab-bar.vue?vue&type=template&id=26c0fb54&scoped=true&"
import script from "./tab-bar.vue?vue&type=script&lang=js&"
export * from "./tab-bar.vue?vue&type=script&lang=js&"
import style0 from "./tab-bar.vue?vue&type=style&index=0&id=26c0fb54&lang=scss&rel=stylesheet%2Fscss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26c0fb54",
  null
  
)

export default component.exports